import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const LanguageContext = createContext(null);

const getInitialLang = () => {
  const params = new URLSearchParams(window.location.search);
  const urlLang = params.get("lang");
  if (urlLang === "fr" || urlLang === "en") return urlLang;
  const stored = localStorage.getItem("khuma_lang");
  if (stored === "fr" || stored === "en") return stored;
  return "fr";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(getInitialLang);
  const [content, setContent] = useState(null);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    try {
      const [c, s] = await Promise.all([api.get("/content"), api.get("/services")]);
      setContent(c.data);
      setServices(s.data);
    } catch (e) {
      if (process.env.NODE_ENV !== "production") console.error("Failed to load content", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    localStorage.setItem("khuma_lang", lang);
    document.documentElement.lang = lang;
    const url = new URL(window.location.href);
    url.searchParams.set("lang", lang);
    window.history.replaceState({}, "", url);
  }, [lang]);

  const toggleLang = () => setLang((l) => (l === "fr" ? "en" : "fr"));

  const t = content ? content[lang] : null;

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, content, t, services, loading, refetch: fetchData }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
